import dayjs from 'dayjs'
import type { MaybeRef } from 'vue'

export class SupportHours {
  static async use() {
    const { flag } = FeatureFlags.use()
    const isAep = computed(() => flag<boolean>('is-aep').value)

    const nowCentral = computed(() => dayjs().tz('America/Chicago'))
    const isWeekend = computed(() => [0, 6].includes(nowCentral.value.day()))

    const getTime = (date: MaybeRef<dayjs.Dayjs>, hour: number) =>
      toValue(date).startOf('day').add(hour, 'h')

    const { getComponentContent } = Cms.use()
    const { content } = await getComponentContent('CsSupportHours')

    const getHours = computed(() => {
      if (isAep.value) {
        return isWeekend.value ? content.value.data.aep.weekend : content.value.data.aep.weekday
      }

      return isWeekend.value ? content.value.data.normal.weekend : content.value.data.normal.weekday
    })

    const isSupportHours = computed(() => {
      const [start, end] = getHours.value

      if (_isNil(start) && _isNil(end)) {
        return false
      }

      if (_isNil(end)) {
        return nowCentral.value.isSameOrAfter(getTime(nowCentral, start))
      }

      return nowCentral.value.isBetween(
        getTime(nowCentral, start),
        getTime(nowCentral, end),
        null,
        '[]'
      )
    })

    return {
      isSupportHours
    }
  }
}
